import { FormattedMessage } from "react-intl";

import { RanaButton, RanaModal, RightArrowIcon } from "@nens/ranalib";

import { useRanaSearchState } from "@/hooks/router/rana-search-state";

import { EventsListDetailed } from "./components/events-list-detailed";
import { UseEventsListProps } from "./hook/use-event-list";

export const EventsListModal = (props: UseEventsListProps) => {
  const { filterBy } = props;
  const [isOpen, setIsOpen] = useRanaSearchState("activity-modal", false, {
    dontEverSaveInHistory: true,
  });

  const buttonText =
    filterBy === "user" ? (
      <FormattedMessage id="events.all_mine" defaultMessage="All my activity" />
    ) : (
      <FormattedMessage id="events.all_project" defaultMessage="All activity" />
    );
  return (
    <>
      <RanaButton
        rightIcon={<RightArrowIcon />}
        variant="fourthiary"
        onClick={() => setIsOpen(true)}
      >
        {buttonText}
      </RanaButton>
      <RanaModal isOpen={isOpen} onClose={() => setIsOpen(false)} topBar={buttonText} pb={8}>
        <EventsListDetailed {...props} />
      </RanaModal>
    </>
  );
};
